import React from "react";

const PatientForm = ({ onSubmit, onClose }) => {
  return (
    <div className="form-overlay">
      <div className="form-container">
        {/* Close button */}
        <button className="close-button" onClick={onClose} aria-label="Close form">
          X
        </button>

        {/* Form title */}
        <h2>Patient Creation Form</h2>

        {/* Form */}
        <form onSubmit={onSubmit}>
          {/* CHI Input */}
          <div className="form-group">
            <label htmlFor="chi">Community Health Identifier (CHI):</label>
            <input type="text" id="chi"
              name="chi"
              placeholder="Enter CHI"
              minLength={10}
              maxLength={10}
              required
            />
          </div>

          {/* Forename Input */}
          <div className="form-group">
            <label htmlFor="forename">Forename:</label>
            <input
              type="text"
              id="forename"
              name="forename"
              placeholder="Enter Forename"
              required
            />
          </div>

          {/* Surname Input */}
          <div className="form-group">
            <label htmlFor="surname">Surname:</label>
            <input
              type="text"
              id="surname"
              name="surname"
              placeholder="Enter Surname"
              required
            />
          </div>

          {/* Date of Birth Input */}
          <div className="form-group">
            <label htmlFor="dob">Date of Birth:</label>
            <input
              type="date"
              id="dob"
              name="dob"
              required
            />
          </div>

          {/* Sex Select */}
          <div className="form-group">
            <label htmlFor="sex">Sex:</label>
            <select id="sex" name="sex" required>
              <option value="">Select Sex</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>

          {/* Postcode Input */}
          <div className="form-group">
            <label htmlFor="postcode">Postcode:</label>
            <input
              type="text"
              id="postcode"
              name="postcode"
              placeholder="Enter Postcode"
              required
            />
          </div>

          {/* Submit Button */}
          <button type="submit" className="submit-button">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default PatientForm;